import { render } from "./AposLogo.vue?vue&type=template&id=9b7614d4"
const script = {}

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"schema/ui/apos/components/AposLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b7614d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b7614d4', __exports__)) {
    api.reload('9b7614d4', __exports__)
  }
  
  module.hot.accept("./AposLogo.vue?vue&type=template&id=9b7614d4", () => {
    api.rerender('9b7614d4', render)
  })

}


export default __exports__